export default __webpack_public_path__ + "static/media/rat.4658acee.png";